
import { defineComponent } from "vue";
import { IComponentsNavigationBarConfig } from "../../types";
import SwipeGestures from "./SwipeGestures.vue";
import NavigationDrawer from "./NavigationDrawer.vue";

export default defineComponent({
  name: "NavigationBar",
  components: { SwipeGestures, NavigationDrawer },
  props: {
    config: { type: Object as () => IComponentsNavigationBarConfig },
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    drawerOnLeftSide(): boolean {
      return this.$store.state.settings.drawerSide === "left";
    },
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    showDrawer() {
      this.drawer = true;
    },
    hideDrawer() {
      this.drawer = false;
    },

    back(route: string) {
      if (route) {
        this.$router.push(route);
      } else {
        this.$router.go(-1);
      }
    },

    swipedLeft() {
      this.drawerOnLeftSide ? this.hideDrawer() : this.showDrawer();
    },
    swipedRight() {
      this.drawerOnLeftSide ? this.showDrawer() : this.hideDrawer();
    },
  },
});
